export default __webpack_public_path__ + "static/media/2017 (2).11fd3e96.jpg";